import React from "react";

import { RadioGroup, RadioGroupItem } from "@components/ui/radio-group";

export type SearchType = "document_type" | "chronological" | "timeline" | null;

type SearchTypeSelectorProps = {
  value: SearchType;
  onChange: (value: SearchType) => void;
};

export const SearchTypeSelector: React.FC<SearchTypeSelectorProps> = ({
  value,
  onChange,
}) => {
  return (
    <div className="mx-2 mt-4 flex items-center gap-3">
      <span className="font-head text-xs font-medium text-foreground">View By:</span>
      <RadioGroup
        value={value ?? ""}
        onValueChange={(val) => onChange(val as SearchType)}
        className="flex flex-row items-center gap-6"
      >
        <label
          htmlFor="search-type-document"
          className="flex cursor-pointer items-center space-x-2"
        >
          <RadioGroupItem value="document_type" id="search-type-document" />
          <span className="font-head text-xs">Document Type</span>
        </label>
        <label
          htmlFor="search-type-chronological"
          className="flex cursor-pointer items-center space-x-2"
        >
          <RadioGroupItem value="chronological" id="search-type-chronological" />
          <span className="font-head text-xs">Chronological Order</span>
        </label>
        <label
          htmlFor="search-type-timeline"
          className="flex cursor-pointer items-center space-x-2"
        >
          <RadioGroupItem value="timeline" id="search-type-timeline" />
          <span className="font-head text-xs">Timeline View</span>
        </label>
      </RadioGroup>
    </div>
  );
};
